<template>
  <div class="ccui-home-index">
    <div class="ccui-app-container-auto">
      <div class="ccui-top-title">概况</div>
      <i class="el-icon-more" @click="openDialog"></i>
      <div class="ccui-statistics-card">
        <el-row :gutter="20">
          <el-col
            :span="6"
            v-for="(item, index) in statisticsCardList"
            :key="index"
          >
            <el-statistics-card
              :num="item.num"
              :newAdd="item.newAdd"
              :iconFont="item.iconFont"
              :typeText="item.typeText"
              :downWords="item.downWords"
            >
            </el-statistics-card>
          </el-col>
        </el-row>
      </div>
    </div>
    <div class="ccui-app-container-auto" v-show="isShowPurchase">
      <div class="ccui-top-title">招标采购</div>
      <i class="el-icon-more" @click="openDialog"></i>
      <div class="ccui-chart-detail-left">
        <div class="ccui-chart-box">
          <div
            ref="myChartPurchase"
            :style="{ width: '300px', height: '300px' }"
          />
          <div class="ccui-chart-center-desc">
            <div>累计金额</div>
            <div>4118.65</div>
            <div>(亿元)</div>
          </div>
          <div class="ccui-chart-desc2">
            <div class="ccui-chart-desc2-text">
              近7日新增(亿元)
              <span>0</span>
            </div>
          </div>
        </div>
        <div class="ccui-dashboard-table">
          <el-table :data="openTender" border style="width: 100%">
            <el-table-column prop="" label="" width="36">
              <template slot-scope="scope">
                <div
                  id="sign"
                  :style="{
                    backgroundColor: dashboardTableStyle[scope.$index]
                  }"
                />
              </template>
            </el-table-column>
            <el-table-column prop="procurement" label="采购方式" width="">
            </el-table-column>
            <el-table-column prop="proMoney" label="预计采购额">
            </el-table-column>
            <el-table-column prop="newMoney" label="新增额"> </el-table-column>
            <el-table-column prop="newly1" label="近七日新增">
            </el-table-column>
            <el-table-column prop="number" label="定标数量"> </el-table-column>
            <el-table-column prop="newly2" label="近七日新增">
            </el-table-column>
          </el-table>
        </div>
      </div>
    </div>
    <div class="ccui-app-container-auto">
      <div class="ccui-top-title">物资采购专区计划采购金额同期对比</div>
      <div class="ccui-chart-detail-full">
        <div
          ref="myChartMaterialsPurchasing"
          :style="{ width: '100%', height: '270px' }"
        />
      </div>
    </div>
    <div class="ccui-app-container-auto">
      <div class="ccui-top-title">询价专区采购趋势图</div>
      <div class="ccui-chart-detail-full">
        <div
          ref="myChartMaterialsEnquiry"
          :style="{ width: '100%', height: '300px' }"
        />
      </div>
    </div>
    <div class="ccui-app-container-auto">
      <div class="ccui-top-title">工程专区采购趋势图</div>
      <div class="ccui-chart-detail-full">
        <div
          ref="myChartMaterialsEngineer"
          :style="{ width: '100%', height: '300px' }"
        />
      </div>
    </div>
    <div class="ccui-app-container-auto">
      <div class="ccui-top-title">订单采购额.Top10</div>
      <div class="ccui-chart-detail-full">
        <div ref="myChartClassify" :style="{ width: '80%', height: '450px' }" />
      </div>
    </div>
    <el-dialog
      title="设置"
      :visible.sync="dialogVisible"
      width="900px"
      custom-class="ccui-home-index-dialog-setting"
      @open="dialogOpen"
      @opened="dialogOpend"
    >
      <div class="ccui-top-title">概况</div>
      <div
        class="ccui-dialog-statistics-card ccui-dialog-item"
        v-if="dialogStatisticsCardHack"
      >
        <el-row :gutter="20">
          <el-col
            :span="8"
            v-for="(item, index) in statisticsCardListAll"
            :key="index"
          >
            <el-statistics-card
              @click.native="
                $event => {
                  statisticsCardActive($event, item, index);
                }
              "
              :class="{ 'ccui-active': getActive(item) }"
              :num="item.num"
              :newAdd="item.newAdd"
              :iconFont="item.iconFont"
              :typeText="item.typeText"
              :downWords="item.downWords"
            >
            </el-statistics-card>
            <p class="ccui-dialog-statistics-card-text">{{ item.name }}</p>
          </el-col>
        </el-row>
      </div>
      <div class="ccui-top-title">招标采购</div>
      <el-checkbox-group
        class="ccui-dialog-item"
        v-model="checkboxPurchase"
        size="small"
      >
        <el-checkbox label="招标采购统计" border></el-checkbox>
      </el-checkbox-group>
      <span slot="footer">
        <el-button
          size="mini"
          type="default-mini"
          @click="dialogVisible = false"
          >取消</el-button
        >
        <el-button
          size="mini"
          type="primary-font-mini"
          @click="dialogVisibleSubmit"
          >确定</el-button
        >
      </span>
    </el-dialog>
  </div>
</template>

<script>
import MyEcharts from "echarts";
export default {
  name: "demo-home",
  data() {
    return {
      //note 概况显示数据
      statisticsCardList: [
        {
          id: 1,
          num: "41118.65",
          newAdd: "13",
          iconFont: "amount-money",
          typeText: "累计招标采购定标金额（亿）",
          downWords: "近七日新增  (亿元) "
        },
        {
          id: 2,
          num: "3809",
          newAdd: "68",
          iconFont: "agree",
          typeText: "累计招标采购定标数量（个）",
          downWords: "近七日新增  (个) "
        },
        {
          id: 3,
          num: "17424.03",
          newAdd: "24",
          iconFont: "money",
          typeText: "累计订单采购金额（万元）",
          downWords: "近七日新增  (万元) "
        },
        {
          id: 4,
          num: "2675",
          newAdd: "92",
          iconFont: "agree",
          typeText: "累计订单数（笔）",
          downWords: "近七日新增  (笔) "
        },
        {
          id: 5,
          num: "8759",
          newAdd: "65",
          iconFont: "shoping-mall",
          typeText: "累计分包商数量（家）",
          downWords: "近七日新增  (家) "
        }
      ],
      //note 概况全部数据
      statisticsCardListAll: [
        {
          id: 1,
          name: "累计招标采购定标金额",
          num: "41118.65",
          newAdd: "13",
          iconFont: "amount-money",
          typeText: "累计招标采购定标金额（亿）",
          downWords: "近七日新增  (亿元) "
        },
        {
          id: 2,
          name: "累计招标采购定标数量",
          num: "3809",
          newAdd: "68",
          iconFont: "agree",
          typeText: "累计招标采购定标数量（个）",
          downWords: "近七日新增  (个) "
        },
        {
          id: 3,
          name: "累计订单采购金额",
          num: "17424.03",
          newAdd: "24",
          iconFont: "money",
          typeText: "累计订单采购金额（万元）",
          downWords: "近七日新增  (万元) "
        },
        {
          id: 4,
          name: "累计订单数",
          num: "2675",
          newAdd: "92",
          iconFont: "agree",
          typeText: "累计订单数（笔）",
          downWords: "近七日新增  (笔) "
        },
        {
          id: 5,
          name: "累计分包商数量",
          num: "8759",
          newAdd: "65",
          iconFont: "shoping-mall",
          typeText: "累计分包商数量（家）",
          downWords: "近七日新增  (家) "
        }
      ],
      //note 招标采购数据
      openTender: [
        {
          procurement: "公开招标",
          proMoney: "2,812.69",
          newMoney: "2,203.37",
          newly1: "0",
          number: "76,030",
          newly2: "0"
        },
        {
          procurement: "邀标",
          proMoney: "1,324.82",
          newMoney: "1,135.94",
          newly1: "0",
          number: "992",
          newly2: "0"
        },
        {
          procurement: "竞争谈判",
          proMoney: "100.48",
          newMoney: "83.09",
          newly1: "0",
          number: "911",
          newly2: "0"
        },
        {
          procurement: "询价",
          proMoney: "171.37",
          newMoney: "147.19",
          newly1: "0",
          number: "4,112",
          newly2: "0"
        },
        {
          procurement: "其他",
          proMoney: "606.77",
          newMoney: "549.05",
          newly1: "0",
          number: "4,112",
          newly2: "0"
        }
      ],
      //note 招标采购数据颜色
      dashboardTableStyle: [
        "#5576cf",
        "#ffb54a",
        "#0298d9",
        "#2b821d",
        "#bd564d"
      ],
      //note 设置dialog的显示
      dialogVisible: false,
      dialogIsOpen: false,
      //note 显示的checkbox
      checkboxPurchase: ["招标采购统计"],
      //note 是否显示招标采购
      isShowPurchase: true,
      //note 用于dialog刷新数据
      dialogStatisticsCardHack: true
    };
  },
  created() {
    this.$store.dispatch("setShowSimpleFooter", true);
  },
  mounted() {
    // 招标采购
    this.chartPurchase();
    // 物资采购专区计划采购金额同期对比
    this.chartMaterialsPurchasing();
    // 询价专区采购趋势图
    this.chartMaterialsEnquiry();
    // 工程专区采购趋势图
    this.chartMaterialsEngineer();
    // 订单采购额
    this.classifyCharts();
  },
  beforeRouteLeave(to, from, next) {
    this.$store.dispatch("setShowSimpleFooter", false);
    next();
  },
  methods: {
    chartPurchase() {
      const myChartPurchase = MyEcharts.init(this.$refs.myChartPurchase);
      myChartPurchase.setOption({
        tooltip: {
          trigger: "item",
          formatter: "{c} ({d}%)"
        },
        series: [
          {
            type: "pie",
            radius: ["45%", "57%"],
            center: ["55%", "47%"],
            clickable: false,
            startAngle: 110,
            minAngle: 15, // 最小角度
            hoverAnimation: false, // 移入放大效果
            animation: false, // 移入放大效果
            data: [
              {
                value: 40,
                name: "公开招标"
              },
              { value: 30, name: "邀标" },
              { value: 10, name: "竞争谈判" },
              { value: 10, name: "询价" },
              { value: 10, name: "其他" }
            ],
            label: {
              show: false,
              position: "center"
            },
            labelLine: {
              show: false
            },
            color: ["#5576cf", "#ffb54a", "#0298d9", "#2b821d", "#bd564d"]
          }
        ]
      });
    },
    chartMaterialsPurchasing() {
      const myChartMaterialsPurchasing = MyEcharts.init(
        this.$refs.myChartMaterialsPurchasing
      );
      myChartMaterialsPurchasing.setOption({
        legend: {
          data: ["2019", "2020"],
          itemGap: 30,
          itemWidth: 23,
          itemHeight: 12,
          textStyle: {
            fontSize: 13,
            verticalAligin: "middle"
          },
          selectorLabel: {
            verticalAligin: "middle"
          }
        },
        grid: {
          bottom: 30
        },
        tooltip: {},
        xAxis: {
          type: "category",
          data: [
            "1月",
            "2月",
            "3月",
            "4月",
            "5月",
            "6月",
            "7月",
            "8月",
            "9月",
            "10月",
            "11月",
            "12月"
          ]
        },
        yAxis: {
          type: "value",
          name: "采购金额（万元）",
          max: 200,
          nameGap: 43,
          nameTextStyle: {
            fontSize: 13,
            color: "#4A4A4A",
            padding: [0, 100, 0, 0]
          }
        },
        series: [
          {
            name: "2019",
            type: "bar",
            barWidth: 16,
            itemStyle: {
              normal: {
                color: "#0089EF"
              }
            },
            data: [200, 125, 50, 50, 50, 50, 50, 50, 50, 50, 50, 50]
          },
          {
            name: "2020",
            type: "bar",
            barWidth: 16,
            itemStyle: {
              normal: {
                color: "#FFB54A"
              }
            },
            data: [140, 50, 30, 30, 30, 30, 30, 30, 30, 30, 30, 30]
          }
        ]
      });
    },
    chartMaterialsEnquiry() {
      const myChartMaterialsEnquiry = MyEcharts.init(
        this.$refs.myChartMaterialsEnquiry
      );
      myChartMaterialsEnquiry.setOption({
        legend: {
          data: ["预计采购金额", "定标金额"],
          itemGap: 30,
          itemWidth: 23,
          itemHeight: 12,
          textStyle: {
            fontSize: 13,
            verticalAligin: "middle"
          },
          selectorLabel: {
            verticalAligin: "middle"
          }
        },
        grid: {
          bottom: 30
        },
        tooltip: {},
        xAxis: {
          type: "category",
          data: [
            "2019/03",
            "2019/04",
            "2019/05",
            "2019/06",
            "2019/07",
            "2019/08",
            "2019/09",
            "2019/10",
            "2019/11",
            "2019/12",
            "2020/01",
            "2020/02"
          ],
          boundaryGap: false
        },
        yAxis: {
          type: "value",
          name: "金额（万元）",
          max: 600,
          nameGap: 43,
          nameTextStyle: {
            fontSize: 13,
            color: "#4A4A4A",
            padding: [0, 100, 0, 0]
          }
        },
        series: [
          {
            name: "预计采购金额",
            type: "line",
            barWidth: 16,
            itemStyle: {
              normal: {
                color: "#0089EF"
              }
            },
            data: [150, 280, 280, 350, 300, 350, 320, 200, 120, 400, 60, 50]
          },
          {
            name: "定标金额",
            type: "line",
            barWidth: 16,
            itemStyle: {
              normal: {
                color: "#FFB54A"
              }
            },
            data: [140, 50, 54, 23, 45, 67, 45, 56, 45, 67, 56, 43]
          }
        ]
      });
    },
    chartMaterialsEngineer() {
      const myChartMaterialsEngineer = MyEcharts.init(
        this.$refs.myChartMaterialsEngineer
      );
      myChartMaterialsEngineer.setOption({
        legend: {
          itemGap: 30,
          itemWidth: 23,
          itemHeight: 12,
          textStyle: {
            fontSize: 13,
            verticalAligin: "middle"
          },
          selectorLabel: {
            verticalAligin: "middle"
          }
        },
        grid: {
          bottom: 30
        },
        tooltip: {},
        xAxis: {
          type: "category",
          data: [
            "2019/03",
            "2019/04",
            "2019/05",
            "2019/06",
            "2019/07",
            "2019/08",
            "2019/09",
            "2019/10",
            "2019/11",
            "2019/12",
            "2020/01",
            "2020/02"
          ],
          boundaryGap: false
        },
        yAxis: {
          type: "value",
          name: "金额（万元）",
          max: 50,
          nameGap: 43,
          nameTextStyle: {
            fontSize: 13,
            color: "#4A4A4A",
            padding: [0, 100, 0, 0]
          }
        },
        series: [
          {
            type: "line",
            barWidth: 16,
            itemStyle: {
              normal: {
                color: "#0089EF"
              }
            },
            data: [50, 30, 23, 35, 37, 30, 35, 22, 28, 23, 25, 10]
          }
        ]
      });
    },
    classifyCharts() {
      const myChartBar = MyEcharts.init(this.$refs.myChartClassify);
      this.option = {
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow"
          }
        },
        grid: {
          left: 111,
          right: 20,
          top: 5,
          bottom: 0,
          containLabel: true
        },
        xAxis: {
          type: "value",
          max: 10000,
          splitNumber: 10
        },
        yAxis: {
          type: "category",
          inverse: true,
          nameLocation: "start",
          data: [
            "中交第二航务工程局有限公司",
            "中交二航局第一工程有限公司",
            "中交二航局第二工程有限公司",
            "中交二航局第三工程有限公司",
            "中交二航局第四工程有限公司",
            "中交二航局第一工程有限公司",
            "中交二航局第一工程有限公司",
            "中交二航局第一工程有限公司",
            "中交二航局第一工程有限公司",
            "中交二航局第一工程有限公司"
          ],
          nameTextStyle: {
            fontSize: 14,
            fontWeight: 400,
            color: "#4A4A4A",
            lineHeight: 20,
            padding: [0, 50, 0, 0]
          }
        },
        series: [
          {
            type: "bar",
            barWidth: 16,
            itemStyle: {
              color: "#0089EF"
            },
            data: [
              "9500",
              "8500",
              "6800",
              "5200",
              "5000",
              "3700",
              "3100",
              "2500",
              "2200",
              "1500"
            ]
          }
        ]
      };
      myChartBar.setOption(this.option);
      window.onresize = function() {
        myChartBar.resize();
      };
    },
    // note 打开设置页面
    openDialog() {
      this.dialogStatisticsCardHack = false;
      this.$nextTick(() => {
        this.dialogStatisticsCardHack = true;
      });
      this.dialogVisible = true;
    },
    // note 设置页面点击概况是否选中
    statisticsCardActive($event, item, index) {
      let $el = $event.currentTarget.classList;
      if ($el.contains("ccui-active")) {
        $el.remove("ccui-active");
        item.isChecked = false;
      } else {
        $el.add("ccui-active");
        item.isChecked = true;
      }
    },
    // note 获取选中状态
    getActive(item) {
      let exist = this.statisticsCardList.find(value => {
        return value.id === item.id;
      });
      if (exist && this.dialogIsOpen === true) {
        item.isChecked = true;
      }
      return exist;
    },
    // note 设置页面打开时调用
    dialogOpen() {
      this.dialogIsOpen = true;
      if (this.isShowPurchase) {
        this.checkboxPurchase = ["招标采购统计"];
      } else {
        this.checkboxPurchase = [];
      }
    },
    // note 设置页面打开结束时调用
    dialogOpend() {
      this.dialogIsOpen = false;
    },
    // note 设置页面确定按钮调用
    dialogVisibleSubmit() {
      this.dialogVisible = false;
      // 概况
      this.statisticsCardList = this.statisticsCardListAll
        .filter(item => {
          return item.isChecked;
        })
        .map(item => {
          return {
            id: item.id,
            num: item.num,
            newAdd: item.newAdd,
            iconFont: item.iconFont,
            typeText: item.typeText,
            downWords: item.downWords
          };
        });

      // 招标采购
      if (this.checkboxPurchase.includes("招标采购统计")) {
        this.isShowPurchase = true;
      } else {
        this.isShowPurchase = false;
      }
    }
  }
};
</script>
